import endpoint from 'middleware/sagas/endpoint'

import { CACHE_TAG_ACCOUNT_INVOICE_LIST } from '../cacheTagTypes'
import api from '../index'

// The account "invoices-by-aging" response; only the invoice id is consumed by callers today.
interface AccountInvoiceByAging {
  id: string
}

interface GetAccountInvoicesByAgingResponse {
  accountInvoices: AccountInvoiceByAging[]
}

interface GetAccountInvoicesByAgingArgs {
  accountId: string
  aging: string
}

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getAccountInvoicesByAging: builder.query<GetAccountInvoicesByAgingResponse, GetAccountInvoicesByAgingArgs>({
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_INVOICE_LIST,
        { type: CACHE_TAG_ACCOUNT_INVOICE_LIST, id: accountId },
      ],
      query: ({ accountId, aging }) => ({
        url: `${endpoint.account.view}/${accountId}/invoices-by-aging`,
        method: 'GET',
        params: { aging },
      }),
    }),
  }),
})

export const { useLazyGetAccountInvoicesByAgingQuery } = extendedApi
